import { RemoveToursAction, GetTourListReset } from '../store/slices/generics/tourSlice'
import { BulbOutlined, FolderOpenFilled } from '@ant-design/icons'
import { GiMagicLamp } from "react-icons/gi";

export const tourStepsConfig = {
    'company/research.portfolio': {
        title: <div style={{color: "#9E8B5B", fontSize: "16px", fontWeight: "600"}}>Portfolio Companies</div>,
        description: (
            <div>
                <p style={{ marginTop: 0, fontSize: '14px' }}>
                    We are replacing the <b>"Company"</b> filter with <b>"Portfolio Companies"</b> filter. Going forward you need to add a Company to Portfolio before initiating Research. Navigate to the <b>"Manage
                    Portfolio"</b> page and use the Country filter and Search option to look for the Company you are interested in and add them to your Portfolio. You can add multiple Companies to your
                    Portfolio at one go. Once the Companies are added to your portfolio, they will be immediately available for Research.
                </p>
                <p>
                    This feature helps in prioritizing the Report downloads for our User portfolio Companies.
                </p>
                <p>
                    We have also introduced a <b>"Disclosure alert"</b> feature on the <b>"Manage Portfolio"</b> page where you can choose to get email alerts (weekly / monthly) for the new disclosures from your Portfolio companies when loaded to ESGSure Platform.
                </p>
            </div>
        ),
        path: '/company/research',
        target: () => document.querySelector('[data-tour-id="company/research.portfolio"]'),
        icon: <FolderOpenFilled style={{ color: '#1890ff', fontSize: 20 }} />,
        tag: 'New',
    },
    'company/research.publicationYear': {
        title: <div style={{color: "#9E8B5B", fontSize: "16px", fontWeight: "600"}}>Publication Year Filter</div>,
        description: (
            <div>
                <p style={{ marginTop: 0 }}>
                    We are replacing the <b>"Fiscal Year"</b> with <b>"Publication Year"</b> filter to avoid confusion around FY calculation of Companies from different regions with different periods of reporting.
                    <b>"Publication Year"</b> indicates the year in which the report was published.
                </p>
                <p>
                    Kindly note that this filter applies to <b>"Periodic publications/reports"</b> like Annual/Integrated Report, Sustainability Report, Statutory filings and not applicable for Policy Docs
                    and Webpages
                </p>
            </div>
        ),
        path: '/company/research',
        target: () => document.querySelector('[data-tour-id="company/research.publicationYear"]'),
        icon: <BulbOutlined style={{ color: '#1890ff', fontSize: 20 }} />,
        tag: 'New',
    },
    'company/research.promptGenie': {
        title: <div style={{color: "#9E8B5B", fontSize: "16px", fontWeight: "600"}}>Prompt Genie</div>,
        description: (
            <div>
                <p style={{ marginTop: 0 }}>
                    <b>"Prompt Genie"</b> helps in enhancing your simple questions to a better quality <b>"Prompt"</b> that helps in improving the accuracy of AI's response.
                    Prompt Genie's recommendations may not be relevant / accurate always. Hence you have the option to <b>"Edit"</b> before running the prompt or you can directly <b>"Ask"</b> if you are happy with the recommended prompt.
                </p>
                <p>You can also provide your feedback on Prompt Genie's recommendation using the thumbs up & down icons.</p>
            </div>
        ),
        path: '/company/research',
        target: () => document.querySelector('[data-tour-id="company/research.promptGenie"]'),
        icon: <GiMagicLamp style={{ color: 'gold', fontSize: 20 }} />,
        tag: 'New',
    },
}
// 'company/doc-source.companyName': {
//     title: 'Company Name',
//     description: 'Filter using Company Name',
//     path: '/company/doc-source',
//     target: () => document.querySelector('[data-tour-id="company/doc-source.companyName"]'),
//     icon: <RocketOutlined style={{ color: '#52c41a', fontSize: 20 }} />,
//     tag: 'Improved',
// },

export const handleFinishTour = (dispatch, completedTour) => {
    if (!dispatch || !completedTour.length) return
    dispatch(RemoveToursAction(completedTour))
    dispatch(GetTourListReset())
}

export const getPendingTourConfig = (pendingTourItems, currentPath) => {
    if (!pendingTourItems || !pendingTourItems.length || !currentPath) return null

    const cleanPath = currentPath.startsWith('/') ? currentPath.slice(1) : currentPath
    const pendingItems = []
    pendingTourItems.forEach((item) => {
        const matchedPendingItem = item.startsWith(cleanPath)
        if (!matchedPendingItem) return false
        const tourConfigKey = Object.keys(tourStepsConfig).find((key) => key.startsWith(item))
        if (tourConfigKey) pendingItems.push(tourStepsConfig[tourConfigKey])
    })
    return pendingItems
}